import {ContentSkeleton} from '/ui/components/contentskeleton/contentskeleton';

export function PageSkeleton() {
  return <div>
    <ContentSkeleton type="box" height={100} />
    <ContentSkeleton numRows={5}/>
  </div>;
}
